import { useQuery } from '@tanstack/react-query';
import { TECHSTACK_COLLECTION } from 'constants/gcConstants';
import { G_TECH_STACKS_QUERY_KEY } from 'constants/queryKeys';
import { GBase } from 'interfaces/IGlobalCatalogue';
import { GlobalCatalogueService } from 'services/GlobalCatalogueServices';

/** Tech stacks, offered on a new variety. */
export const useFetchGTechStacks = (enabled = true) => {
  return useQuery<GBase[]>({
    queryKey: [G_TECH_STACKS_QUERY_KEY],
    queryFn: () =>
      GlobalCatalogueService.FetchGReferenceCollectionData(
        TECHSTACK_COLLECTION
      ),
    staleTime: 1000 * 60 * 30,
    enabled,
  });
};
